import mitt from 'mitt';

// Vue 3 : plus de bus d'événements via l'instance racine ($root.$emit/$on).
// Ce mitt remplace les usages `bv::show::modal` / `bv::hide::modal` du login modal.
type Events = {
  'show-login': void;
  'hide-login': void;
  'space:updated': void;
};

export const emitter = mitt<Events>();
